import { version } from 'react';
import { createRoot } from 'react-dom/client';
export { useState, useCallback, Component } from 'react';
export var libName = "React v".concat(version);
export var render = function (element, container) {
    var root = createRoot(container);
    root.render(element);
};
